import Modal from "../shared/Modal";
import "./ModalBasicConfirm.css";

export type ModalBasicConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  onContinue: () => void;
  continueLabel?: string;
  allowClickout?: boolean;
  allowDismiss?: boolean;
};

const ModalBasicConfirm = ({
  isOpen,
  onClose,
  title,
  message,
  onContinue,
  continueLabel = "Continue",
  allowClickout = true,
  allowDismiss = true,
}: ModalBasicConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={allowDismiss}
        allowClickout={allowClickout}>
        <div id="modal-basic-confirm">
          <div className="modal-basic-confirm-title">{title}</div>

          <div className="modal-basic-confirm-content">{message}</div>

          <div className="modal-basic-confirm-footer">
            <div className="modal-basic-confirm-buttons">
              {allowDismiss && (
                <button
                  onClick={onClose}
                  className="collections-button-negative">
                  Dismiss
                </button>
              )}

              <button onClick={onContinue} className="collections-button">
                {continueLabel}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalBasicConfirm;
